import React from 'react';
import { connect } from 'react-redux';

import PasoUnoPreguntas from './pasoUnoPreguntas.cmpt.js';
import PasoDosPreguntas from './pasoDosPreguntas.cmpt.js';
import PasoTresPreguntas from './pasoTresPreguntas.cmpt.js';

const mapState = (state) => {
    return {
        paso: state.miPerfil.pasoPreguntas
    };
}

const mapDispatch = (dispatch) => {
    return {}
}

class ModalCambiarPreguntas extends React.Component {
	state = {}
	
	render() {
		return <div>
            { this.props.paso == 0 && 
                <PasoUnoPreguntas />
            }
            { this.props.paso == 1 && 
                <PasoDosPreguntas />
            }
            { this.props.paso == 2 && 
                <PasoTresPreguntas />
            }
        </div>
	}
}

export default connect(mapState, mapDispatch)(ModalCambiarPreguntas);


// WEBPACK FOOTER //
// ./src/miPerfil/modalCambiarPreguntas.cmpt.js